import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import ComTable from "./components/ComTable.vue";
import "./utils/inputTrim.js";
Vue.component("ComTable", ComTable);
// // 引入iconfont
import IconFont from "@/components/Icon/index.js";
Vue.use(IconFont);
import "@/styles/index.scss"; // global css
Vue.use(ElementUI, { size: "medium" });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
